/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

import moduleAuth from './modules/auth.js'
import moduleUsers from './modules/users.js'
import moduleProducts from './modules/products.js'
import moduleOrders from './modules/orders.js'
import modulePosts from './modules/posts.js'
import moduleTransactions from './modules/transactions.js'
import moduleFactors from './modules/factors.js'
import moduleChat from './modules/chat.js'
import moduleWarranties from './modules/warranty.js'

Vue.use(Vuex)


export default new Vuex.Store({
    getters,
    mutations,
    state,
    actions,
    modules: {
      auth: moduleAuth,
      users: moduleUsers,
      products: moduleProducts,
      orders: moduleOrders,
      posts: modulePosts,
      transactions: moduleTransactions,
      factors: moduleFactors,
      chat: moduleChat,
      warranties: moduleWarranties,
    },
    strict: process.env.NODE_ENV !== 'production'
})
